export const MenuItems = [
    {
        title: "DLACZEGO WARTO?",
        url: "/whatisit",
        cName: "nav-links",
    },
    {
        title: "GALERIA",
        url: "",
        cName: "nav-links",
    },
    /* {
        title: "REALIZACJE",
        url: "/projects",
        cName: "nav-links",
    }, */
    {
        title: "O NAS",
        url: "/about",
        cName: "nav-links",
    },
    {
        title: "CENNIK",
        url: "/prices",
        cName: "nav-links",
    },
    {
        title: "KONTAKT",
        url: "/contact",
        cName: "nav-links",
    },
];
